import { useState } from 'react'

import { Box, Tab, Tabs } from '@mui/material'
import { Link } from 'react-router-dom'

import AccountPayableDocumentsHistoryTab from 'components/accountsPayable/AccountPayableDocuments/AccountPayableDocumentsHistoryTab'
import AccountPayableDocumentsJobDetailsTab from 'components/accountsPayable/AccountPayableDocuments/AccountPayableDocumentsJobDetailsTab'
import { TabPanel } from 'components/common'
import { useHashToSelectTab } from 'helpers'
import { Restricted, usePermission } from 'providers'

enum TabId {
  JobDetails = 0,
  History = 1,
}

const tabsList = [
  { id: TabId.JobDetails, label: 'Job Details', hash: '#job-details' },
  { id: TabId.History, label: 'History', hash: '#history' },
]

function TabsPanel() {
  const [tabValue, setTabValue] = useState<number | false>(false)

  const [isAllowedToViewHistory] = usePermission('ViewAccountPayableRecordLogs')

  const permissionMap = {
    [TabId.History]: isAllowedToViewHistory,
  }

  const getTabPermission = (tabId: TabId) =>
    permissionMap[tabId] === undefined || permissionMap[tabId] ? 'block' : 'none'

  useHashToSelectTab(tabsList, setTabValue)

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', pt: 2 }}>
        <Tabs value={tabValue} aria-label='account-payable-documents'>
          {tabsList.map((tab) => (
            <Tab
              label={tab.label}
              key={tab.id}
              component={Link}
              sx={{ display: getTabPermission(tab.id) }}
              to={{ hash: tab.hash }}
            />
          ))}
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={TabId.JobDetails} elevation={0}>
        <AccountPayableDocumentsJobDetailsTab />
      </TabPanel>
      <Restricted to='ViewAccountPayableRecordLogs'>
        <TabPanel value={tabValue} index={TabId.History} elevation={0}>
          <AccountPayableDocumentsHistoryTab />
        </TabPanel>
      </Restricted>
    </>
  )
}

export default TabsPanel
